import { ColumnData } from "@gripp/shared-ui";
import { View } from "react-native";
import { AccountSettings } from './components/accountSettings';
import { AccountSettingsMenu } from './components/accountSettingsMenu';
import { Preferences } from "./components/preferences";
import { WorkspacesUser } from './components/workspacesUser';

export enum SETTINGS_COLUMNS_ID {
  SETTINGS = 'settings',
  ACCOUNT = 'account',
  PREFERENCES = 'preferences',
}

export enum SETTINGS_ACCOUNT_SETTINGS_PAGES {
  PROFILE = 'profile',
  PREFERENCES = 'preferences',
  WORKSPACE = 'workspace',
}

// Default columns data with multiple examples
export const SettingColumns: ColumnData[] = [
  {
    id: SETTINGS_COLUMNS_ID.SETTINGS,
    title: 'preferences.settings.title',
    mainComponent: (
      <>
        <View>
          <WorkspacesUser />
        </View>
        <View>
          <AccountSettingsMenu />
        </View>
      </>
    )
  },
  {
    id: SETTINGS_COLUMNS_ID.ACCOUNT,
    title: 'preferences.settings.title',
    mainComponent: <AccountSettings />
  },
  // TODO: Crop Circle Redesign | Remove this column when the redesign is done
  {
    id: SETTINGS_COLUMNS_ID.PREFERENCES,
    title: 'preferences.settings.title',
    mainComponent: <Preferences />
  }
];